
<template>
<b-modal
    v-if="validation"
    ref="modal"
    id="agErrorsModal"
    class="agModal"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="editButton_click">
    <template slot="modal-header">
      <h4 class="agModal-title">{{title}}</h4>
    </template>
        <ul v-if="(validation.errors.length + validation.warnings.length) > 0" id="agErrorsModal-list">
            <li v-for="(error, index) in validation.errors" :key="'error-' + index">
                <fa class="agErrorsModal-errorListItem" icon="exclamation-circle"/><span>{{error}}</span>
                <hr>
            </li>
            <li v-for="(warning, index) in validation.warnings" :key="'warning-' + index">
                <fa class="agErrorsModal-warningListItem" icon="exclamation-triangle"/><span>{{warning}}</span>
                <hr>
            </li>
        </ul>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-button :disabled="validation.object == null" class="agModal-buttonRight" variant="primary" @click="editButton_click">Edit</b-button>
    </template>
  </b-modal>
</template>






<script>

// components


// modules


export default {
    name: "ag-errors-modal",

    components: {

    },

    props:{
        validation: Object,
        title: String
    },

    data(){
        return {
            
        };
    },

    computed: {
        
    },
    
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        editButton_click() {
            this.hide();
            this.$emit("editNode", this.validation);
        },
          
        // emitted Events


        // other

        show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          
        }
    }
}

</script>






<style scoped lang="css">

 #agErrorsModal-list {
     position: relative;
     height: 250px;
     padding: 0px;
     list-style: none;
     overflow: auto;
 }

#agErrorsModal-list li {
      margin: 15px 0px;
 }

 #agErrorsModal-list li span {
     display: inline-block;
     width: calc(100% - 30px);
 }

 #agErrorsModal-list li hr {
     width: 90%;
     margin: 5px auto;
 }

.agErrorsModal-errorListItem{
    vertical-align: top;
    margin-right: 10px;
    margin-top: 2.5px;
    color: #DC3545;
 }

.agErrorsModal-warningListItem {
    vertical-align: top;
    margin-right: 10px;
    margin-top: 2.5px;
    color: #ffd40f;
 }


</style>



// WEBPACK FOOTER //
// src/components/workflow/ErrorsModal.vue